<script setup lang="ts">
import VCallToAction from '@shared/component/VCallToAction/VCallToAction.vue';
import VContentBox from '@shared/component/VContentBox/VContentBox.vue';
import VInfoBox from '@shared/component/VInfoBox/VInfoBox.vue';
import VPageContainer from '@shared/layout/VPageContainer/VPageContainer.vue';
import { useQuery } from '@tanstack/vue-query';
import axios from 'axios';
import { toRefs } from 'vue';

import RelatieGegevensLopendeActiviteit, {
  type Item,
} from './RelatieGegevensLopendeActiviteit.vue';

const props = defineProps<{
  relatienummer: number;
}>();

const { relatienummer } = toRefs(props);

const { data, isPending } = useQuery({
  queryKey: ['lopendeAanvragen', relatienummer.value],
  queryFn: () =>
    axios.get<Array<Item>>(`/net/relation/GetRequests`, {
      params: { relationNumber: relatienummer.value, json: true },
    }),
});
</script>

<template>
  <VPageContainer container-size="sm" title="Aanvragen">
    <VInfoBox type="danger" v-if="!isPending && data?.status !== 200">
      Er is een onbekende fout opgetreden. Probeer het later opnieuw.
    </VInfoBox>
    <RelatieGegevensLopendeActiviteit :items="data?.data" :loading="isPending" />
    <VContentBox v-if="!isPending && data?.data.length === 0">
      <VCallToAction
        class="py-16"
        title="Er zijn momenteel geen lopende aanvragen voor deze relatie."
        icon="far fa-file-contract"
      />
    </VContentBox>
  </VPageContainer>
</template>
